// @ts-nocheck
import Events from './events';
import * as methods from './native/index';
import webMethods from './web/index';
import * as Comps from './components/index';
import { renderDebugView } from './statView';
const IS_IN_APP = typeof grounds !== 'undefined';
const externalCallHandler = (name, args) => {
    if (webMethods[name]) {
        return webMethods[name](...args);
    }
    console.log(`Grounds：在外部环境调用了客户端方法：${name}()`);
    return new Proxy({}, {
        get: function (target, prop, receiver) {
            if (typeof prop === 'symbol' || prop === 'toString' || prop === 'valueOf') {
                return () => Grounds.__mock_value__ || null;
            }
            else {
                return externalCallHandler.bind(null, `${name}().${prop}`);
            }
        }
    });
};
let Methods = {};
if (!IS_IN_APP) {
    Object.keys(methods).forEach(item => {
        Methods[item] = (...args) => externalCallHandler(item, args);
    });
}
else {
    Methods = methods;
}
const Grounds = Object.assign(Object.assign(Object.assign({}, Methods), Comps), { mock: function (val) {
        if (IS_IN_APP)
            return this;
        Grounds.__mock_value__ = val;
        return externalCallHandler('mock');
    } });
Events.mixTo(Grounds);
renderDebugView(Grounds);
export default Grounds;
